// @ constants  
const actionTypes = require('constants/actionTypes');

const setPersoneticsAccountMovementRequest = payload => ({
    type: actionTypes.SET_PERSONETICS_ACCOUNT_MOVEMENT_REQUEST,
    payload
});

const setPersoneticsCardMovementRequest = payload => ({
    type: actionTypes.SET_PERSONETICS_CARD_MOVEMENT_REQUEST,
    payload
});

const setPersoneticsEmitedTransferMovementRequest = payload => ({
    type: actionTypes.SET_PERSONETICS_EMITED_TRANSFER_MOVEMENT_REQUEST,
    payload
});

module.exports = {
    setPersoneticsAccountMovementRequest,
    setPersoneticsCardMovementRequest,
    setPersoneticsEmitedTransferMovementRequest
}